import { getRadius } from "@mantine/core";

import { colors } from "#app/theme/v1/colors";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { useAlertChip } from "#modules/quoteRequestLines/views/useAlertChip";
import { Icon } from "#shared/icons/Icon";
import { Box } from "#shared/view/components/Box";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";
import { Tooltip } from "#shared/view/designSystem/Tooltip";
import { AssemblyWithChildren } from "shared";

export const AlertChip = ({
  quoteRequestLine,
  assemblyChildren,
}: {
  quoteRequestLine: QuoteRequestLineDto;
  assemblyChildren: AssemblyWithChildren<QuoteRequestLineDto>[];
}) => {
  const { hasAlert, alertCount, previewMessage, detailedMessages } = useAlertChip(
    quoteRequestLine,
    assemblyChildren,
  );
  const clickable = hasAlert && alertCount > 1;

  if (!hasAlert) {
    return null;
  }

  return (
    <Tooltip
      multiline
      withArrow
      label={detailedMessages.map((message, index) => (
        <Text key={index}>{message}</Text>
      ))}
    >
      <Box
        size={12}
        variant="light"
        style={{
          borderRadius: getRadius("xs"),
          cursor: clickable ? "pointer" : "default",
        }}
        bg={colors.orange[1]}
        px={6}
      >
        <Flex c={colors.orange[7]}>
          <Icon name="alertTriangle" size={12} style={{ marginRight: 4 }} />
          <Text fz={12}>
            {previewMessage} {alertCount > 1 ? `(+${alertCount - 1})` : ""}
          </Text>
        </Flex>
      </Box>
    </Tooltip>
  );
};
